export default __webpack_public_path__ + "static/media/ig-white.94165f48.svg";